import { render, staticRenderFns } from "./ContentFeedMatchPicker.vue?vue&type=template&id=238b6400&scoped=true"
import script from "./ContentFeedMatchPicker.vue?vue&type=script&lang=js"
export * from "./ContentFeedMatchPicker.vue?vue&type=script&lang=js"
import style0 from "./ContentFeedMatchPicker.vue?vue&type=style&index=0&id=238b6400&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238b6400",
  null
  
)

export default component.exports